
import {IUserLogEntryBuilder} from './i.user.log.entry.builder';
import {IUserLogEntryOptions} from './i.user.log.entry.options';
import {UserLogEntryHelper} from "@/models/userlog/user.log.entry.helper";

/**
 *
 * @class CanPassIgnoreBuilder
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      May 2021
 *
 */
export class CanPassIgnoreBuilder implements IUserLogEntryBuilder {

  /** convert raw MongoDB user log entry into data that can construct a tree node */
  build(data: any, args: IUserLogEntryOptions): any {

    const u:        string = data._id.match(/^can-pass-ignore-(.*)/i)[1];

    let targetTrain:   any = null;
    let train:         any = null;
    let direction:  string = data.d;
    let track:         any = null;
    let parking:       any = null;

    const opposing: string = data.op;

    if (data.tt) {

      targetTrain = {
        id:              data._id,
        name:            `${data.tt.n}-${data.tt.d} [ ${data.tt.src.n} - ${data.tt.dst.n} ] ${data.tt.tp}-${data.tt.u}`,
        uuid:            data.tt.u,
        kind:            data.tt.tp,
        direction:       data.tt.d,
        source: {
          name:          data.tt.src.n,
          mileage:       data.tt.src.m
        },
        destination: {
          name:          data.tt.dst.n,
          mileage:       data.tt.dst.m
        },
        trainClass:      data.tt.tc,
        tonnage:         data.tt.ton,
        length:          data.tt.l,
        priority:        data.tt.pri,
        overtake:        data.tt.o,
        u:               data.tt._id
      };
    }

    if (data.tr) {

      targetTrain = {
        id:              data._id,
        name:            `${data.tr.n}-${data.tr.d} [ ${data.tr.src.n} - ${data.tr.dst.n} ] ${data.tr.tp}-${data.tr.u}`,
        uuid:            data.tr.u,
        kind:            data.tr.tp,
        direction:       data.tr.d,
        source: {
          name:          data.tr.src.n,
          mileage:       data.tr.src.m
        },
        destination: {
          name:          data.tr.dst.n,
          mileage:       data.tr.dst.m
        },
        trainClass:      data.tr.tc,
        tonnage:         data.tr.ton,
        length:          data.tr.l,
        priority:        data.tr.pri,
        overtake:        data.tr.o,
        u:               data.tr._id
      };
    }

    if (data.pk) {

      let before: any    = null;
      let after: any     = null;

      if (data.pk.a != null) {

        after = {
          name:    data.pk.a.d,
          mileage: data.pk.a.m
        };
      }

      if (data.pk.b != null) {

        before = {
          name:    data.pk.b.d,
          mileage: data.pk.b.m
        };
      }

      parking = {
        id:      data.pk.i,
        track:   data.pk.t,
        mileage: data.pk.m,
        before,
        after
      };
    }


    if (data.tk) {

      let before: any    = null;
      let after: any     = null;

      if (data.tk.a != null) {

        after = {
          name:    data.tk.a.d,
          mileage: data.tk.a.m
        };
      }

      if (data.tk.b != null) {

        before = {
          name:    data.tk.b.d,
          mileage: data.tk.b.m
        };
      }

      parking = {
        id:      data.tk.i,
        track:   data.tk.t,
        mileage: data.tk.m,
        before,
        after
      };
    }

    const pkName: string     = UserLogEntryHelper.trackString(data.pk);
    const tkName: string     = UserLogEntryHelper.trackString(data.tk);
    let ttName: string       = '';
    let tName: string        = '';

    if (targetTrain != null) {

      ttName = ` [ ${targetTrain.name}-${targetTrain.direction} ${targetTrain.uuid} ]`;
    }

    if (train != null) {

      tName = ` [ ${train.name}-${train.direction} ${train.uuid} ]`;
    }

    return {
      id:              data._id,
      seq:             parseInt(data.seq),
      name:            `Can Pass (Ignore): ${tName} ? ${ttName} TRACK: ${tkName} PARK: ${pkName}`,
      hasChildren:     args.hasChildren,
      isExpanded:      args.isExpanded,
      type:            'can-pass-ignore',
      children:        args.children,
      parent:          args.parent,
      kids:            data.ch,
      tags:            data.tg,
      label:           data.lb,
      pkey:            data.pa,
      direction,
      train,
      targetTrain,
      track,
      parking,
      u:               data._id
    };

  }
}
